export class UserPermissions {
  public static readonly AcceptDeclineAipApp = 'AcceptDeclineAipApp';
  public static readonly AcceptRecommendation = 'AcceptRecommendation';
  public static readonly AccessCode = 'AccessCode';
  public static readonly AddAdminNotes = 'AddAdminNotes';
  public static readonly AddAdviceNote = 'AddAdviceNote';
  public static readonly AddCaseNote = 'AddCaseNote';
  public static readonly AddTemporaryFirm = 'AddTemporaryFirm';
  public static readonly AssessCase = 'AssessCase';
  public static readonly AssignCaseAdministrator = 'ManageCaseAdministrator';
  public static readonly AssignInternalRoles = 'AssignInternalRoles';
  public static readonly AssociateCustomerToSummitAccount = 'AssociateCustomerToSummitAccount';
  public static readonly BarExternalUser = 'BarExternalUser';
  public static readonly BarFirm = 'ManageFirmCompanyData';
  public static readonly CallLogging = 'CallLogging';
  public static readonly ChangeAdviceOwner = 'ChangeAdviceOwner';
  public static readonly ChangeCaseOwner = 'ChangeCaseOwner';
  public static readonly ChangeTeam = 'ChangeTeam';
  public static readonly ChangeSamId = 'ChangeSamId';
  public static readonly CompareAipApp = 'CompareAipApp';
  public static readonly CreateAip = 'CreateAip';
  public static readonly CreateAipFromKfi = 'CreateAipFromKfi';
  public static readonly CreateApp = 'CreateApp';
  public static readonly CreateAppFromAip = 'CreateAppFromAip';
  public static readonly CreateCase = 'CreateCase';
  public static readonly CreateExpiredKfi = 'CreateExpiredKfi';
  public static readonly CreateKfi = 'CreateKfi';
  public static readonly CreateProductTags = 'CreateProductTags';
  public static readonly CreateRoles = 'CreateRoles';
  public static readonly EditAip = 'EditAip';
  public static readonly EditApp = 'EditApp';
  public static readonly EditDecisionText = 'EditDecisionText';
  public static readonly EditIncompleteAip = 'EditIncompleteAip';
  public static readonly EditIncompleteApp = 'EditIncompleteApp';
  public static readonly EditLegalCopy = 'EditLegalCopy';
  public static readonly EditPageCopy = 'EditPageCopy';
  public static readonly EditPolicyRuleText = 'EditPolicyRuleText';
  public static readonly EditSubmittedAip = 'EditSubmittedAip';
  public static readonly EditSubmittedApp = 'EditSubmittedApp';
  public static readonly EftCancelPayments = 'EFTCancelPayments';
  public static readonly EftCompletePayments = 'EFTCompletePayments';
  public static readonly EftMakePayments = 'EFTMakePayments';
  public static readonly EftMakeRefunds = 'EFTMakeRefunds';
  public static readonly EftViewPayments = 'EFTViewPayments';
  public static readonly GenerateBrokenPdf = 'GenerateBrokenPdf';
  public static readonly HideAdminNotes = 'HideAdminNotes';
  public static readonly HideCaseNote = 'HideCaseNote';
  public static readonly InitiateManualAmlCheck = 'InitiateManualAMLCheck';
  public static readonly LockAdviceCase = 'LockAdviceCase';
  public static readonly LockCase = 'LockCase';
  public static readonly ManageBranchUsers = 'ManageBranchUsers';
  public static readonly ManageBrokerUsers = 'ManageBrokerUsers';
  public static readonly ManageCaseAdministrator = 'ManageCaseAdministrator';
  public static readonly ManageConfiguration = 'ManageConfigurationParameters';
  public static readonly ManageCreditScores = 'ManageCreditScores';
  public static readonly ManageDirectUsers = 'ManageDirectUsers';
  public static readonly ManageLoanGroups = 'ManageLoanGroups';
  public static readonly ManageLocationGroups = 'ManageLocationGroups';
  public static readonly ManageLocations = 'ManageLocations';
  public static readonly ManageProducts = 'ManageProducts';
  public static readonly ManageProfile = 'ManageProfile';
  public static readonly ManagePropositions = 'ManagePropositions';
  public static readonly MarkCaseAsAdvised = 'MarkCaseAsAdvised';
  public static readonly MarkCaseAsDuplicate = 'MarkCaseAsDuplicate';
  public static readonly MarkCaseAsNotProceeding = 'MarkCaseAsNotProceeding';
  public static readonly MarkCaseAsSignedOfferReceived = 'MarkCaseAsSignedOfferReceived';
  public static readonly MarkDocumentAsReviewed = 'MarkDocumentAsReviewed';
  public static readonly MarkFeesAsPaid = 'MarkFeesAsPaid';
  public static readonly PayFees = 'PayFees';
  public static readonly PublishMortgageIllustration = 'PublishMortgageIllustration';
  public static readonly RefreshKycStatus = 'RefreshKYCStatus';
  public static readonly RefundFees = 'RefundFees';
  public static readonly ReleaseAssessment = 'ReleaseAssessment';
  public static readonly ReplaceMortgageIllustration = 'ReplaceMortgageIllustration';
  public static readonly SubmitAip = 'SubmitAip';
  public static readonly SubmitApp = 'SubmitApp';
  public static readonly SwitchOfferDistributionChannel = 'SwitchOfferDistributionChannel';
  public static readonly SwitchOffPropositionInterfaceType = 'SwitchOffPropositionInterfaceType';
  public static readonly UploadDistributedDocument = 'UploadDistributedDocument';
  public static readonly UploadPackagingDocument = 'UploadPackagingDocument';
  public static readonly UpdateBranchDetails = 'UpdateBranchDetails';
  public static readonly ViewAuditData = 'ViewAuditData';
  public static readonly ViewBranchUsers = 'ViewBranchUsers';
  public static readonly ViewBrokerUsers = 'ViewBrokerUsers';
  public static readonly ViewCase = 'ViewCase';
  public static readonly ViewCases = 'ViewCases';
  public static readonly ViewConfigurationData = 'ViewConfigurationData';
  public static readonly ViewDirectUsers = 'ViewDirectUser';
  public static readonly ViewFirmData = 'ViewFirmData';
  public static readonly ViewIncompleteFF1 = 'ViewIncompleteFF1';
  public static readonly ViewLocationGroups = 'ViewLocationGroups';
  public static readonly ViewLocations = 'ViewLocations';
  public static readonly ViewProducts = 'ViewProducts';
  public static readonly ViewProposedProducts = 'ViewProposedProducts';
}
